const addEvent = () => {
  if (!window?.digitalData) {
    window.digitalData = {};
  }
  if (!window.digitalData?.events) {
    window.digitalData.events = [];
  }
};

const addChanges = () => {
  if (!window?.digitalData) {
    window.digitalData = {};
  }
  if (!window.digitalData?.changes) {
    window.digitalData.changes = [];
  }
};

export const pushDigitalData = (eventPush) => {
  addEvent();
  window.digitalData.events.push(eventPush);
};

export const changesDigitalData = (eventPush) => {
  addChanges();
  window.digitalData.changes.push(eventPush);
};
